import { Environments } from "@itb-monorepo/enums";

export const environment = {
  name: Environments.DEVELOPMENT,
  baseUrl: 'https://api.itbfx.dev',
  recaptcha: {
    siteKey: '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',
  },
postHog: {
    key: "phc_hEk6koS9EtOTy74haGmYeDgGHKwcLuPQErUHvDxm3Gk",
    host: "https://posthog.itbfx.dev"
  },
  plugins: [
  {
    enabled: true,
    import: () => import(`plugins/F50-campaign/src/plugin`),
  },
]
};
